import { mainApi, queryFnNotifyWrapper } from 'modules/api';
import { IWithConnectionKeyParams } from 'modules/api/types';
import { getConnectedIotaProvider } from 'modules/auth';
import { authCacheTags } from 'modules/auth/authCacheTags';
import { currentEnv } from 'modules/common';

import { getBalances, IGetBalancesResult } from '../api/getBalances';
import { stakeCacheTags } from '../stakeCacheTags';

export const { useGetBalancesQuery } = mainApi.injectEndpoints({
  endpoints: build => ({
    getBalances: build.query<IGetBalancesResult, IWithConnectionKeyParams>({
      queryFn: queryFnNotifyWrapper<
        IWithConnectionKeyParams,
        void,
        IGetBalancesResult
      >(async () => {
        const provider = getConnectedIotaProvider();

        return {
          data: await getBalances({
            walletAccount: provider.getWalletAccount(),
            client: provider.getClient(),
            env: currentEnv,
          }),
        };
      }),
      providesTags: [authCacheTags.account, stakeCacheTags.getBalances],
    }),
  }),
});
